module.exports = __webpack_public_path__ + "static/media/honda-go-drive.9dad361d.png";